module.exports = __webpack_public_path__ + "media/images/animations/number_of_tires/4-4531ff10e4893419c9b65b761ebcb523.png";